import { render, staticRenderFns } from "./rg-info.vue?vue&type=template&id=0ae7434e&"
import script from "./rg-info.vue?vue&type=script&lang=ts&"
export * from "./rg-info.vue?vue&type=script&lang=ts&"
import style0 from "./rg-info.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports